import React from "react";

const FormRight = ({ children, className }) => {
	return (
		<div className={`form-right gap-y-24px flex flex-col ${className}`}>
			{children}
		</div>
	);
};

export default FormRight;
